import axios from 'axios';
/**
 * WidgetsService
 */
export default class WidgetsService
{
    /**
     * @param websiteId number
     * @param locale string
     * @param search string
     * @param limit number
     *
     * @returns Promise<WidgetModel[]>
     */
    public static async getAutocompletePlaceholders(websiteId: number = null, locale: string = null, search: string, limit: number = 10): Promise<WidgetModel[]>
    {
        return (await axios.get<WidgetModel[]>(`admin/cms/widgets/${websiteId}/${locale}/placeholders/autocomplete`, {
            params: {
                search: search,
                limit: limit
            }
        })).data;
    }

    /**
    * @param websiteId number
    * @param locale string
    * @param id number
    *
    * @returns Promise<WidgetModel>
    */
    public static async fetchAutocompletePlaceholder(websiteId: number = null, locale: string = null, id: number): Promise<WidgetModel>
    {
        return (await axios.get<WidgetModel>(`admin/cms/widgets/${websiteId}/${locale}/placeholders/autocomplete/${id}`)).data;
    }

    /**
     * @param id number WidgetId
     *
     * @returns Promise<WidgetPageListModel[]>
     */
    public static async GetPagesByWidgetId(id: number): Promise<WidgetPageListModel[]>
    {
        return (await axios.get<WidgetPageListModel[]>(`admin/cms/pages/widget/${id}`)).data;
    }
}

export interface WidgetModel
{
    id: number;
    name: string;
    widget: string;
    isActive: boolean;
}

export interface WidgetForm
{
    id: number;
    websiteId: number;
    locale: string;
    name: string;
    widget: string;
    isActive: boolean;
    hideName: boolean;
    displayName: string;
    settings: any;
}

export interface WidgetPageListModel
{
    id: number;
    name: string;
    folderName: string;
    regionName: string;
    layoutId: number;
    layoutName: string;
}
